<div class="template-container">
    <div class="card-block">
      <div class="block-body d-flex">
        <div class="block-container">
          <div class="fw-bold title">{{'template.configuration' | translate}}</div>
          <div class="d-flex justify-content-between">
            <div class="term-block">
              <div class="fw-600">{{'template.bulding' | translate}}</div>
              <div class="fw-600">{{'template.shade-house' | translate}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-footer">
        <div class="fw-bold title">{{'template.results' | translate}}</div>
        <div class="request-chain">
          <div class="d-inline-block color-basic-600 fw-600 ps-0 text-uppercase">
            {{'content.except' | translate}}
          </div>
          <div class="d-inline-block fw-bold">{{'template.bulding' | translate}} </div>
          <div class="d-inline-block color-basic-600 fw-600 ps-1 text-uppercase">
            {{'content.except' | translate}}
          </div>
          <div class="d-inline-block fw-bold">{{'template.shade-house' | translate}} </div>
        </div>
      </div>
    </div>
    <app-example-guide-template [examples]="examples"></app-example-guide-template>
  </div>
